export default "__VITE_ASSET__DRfPRK1N__"